<template>
  <div>
    <!-- Game Content -->
    <div class="row justify-content-center">
      <div class="card shadow customs-card card-fix-height mx-2">
        <!-- Game Content Name -->
        <div v-if="game.status !== 'prize'">
          <div class="card-header border-0 py-2 mt-4 background-card">
            <p class="text-center mb-0 font-weight-bold headline text-white">
              {{ campaign.name }}
            </p>
          </div>

          <div class="mt-3 text text-center text-muted ml-3 mr-3">
            <span style="word-wrap:break-word" v-html="campaign.description"></span>
          </div>

          <div class="mt-3 text text-center text-muted"
            v-if="campaign.num_of_repetition > 1">
            <strong class="text">
              {{parseInt(turnDisplay)}}回目の挑戦中!
            </strong>
          </div>
        </div>

        <!-- Start Content -->
        <div
          class="card-body p-4 row mt-3"
          v-if="game.status === 'start'"
        >
          <div class="d-flex card-flex"
            v-for="(image_top, index) in (campaign.image_of_content_top)"
            :key="'start' + index">
            <img
              :src="image_top"
              v-show="game.status === 'start'"
              @click="selectTopImage(index)"
              alt="image_top"
              class="img-fluid mx-auto fixed-height-img"
              :class="{
                'active-image': (index === activeTopIndex) && (hasTopImage)
              }"
              role="button"
            />
          </div>
        </div>

        <!-- Not start Content -->
        <div
          class="card-body d-flex justify-content-center"
          v-else
        >

          <!-- Before Loading Content -->
          <img
            v-if="game.status === 'pre-loading'"
            key="pre-loading"
            :src="campaign.image_of_content_before_load"
            alt="image_of_content_before_load"
            class="img-fluid mx-auto"
          />

          <!-- Loading Content -->
          <!-- <img
            v-if="game.status === 'loading'"
            key="loading"
            :src="campaign.image_of_content_load"
            alt="image_of_content_load"
            class="img-fluid mx-auto"
          /> -->

          <!-- After Loading Content -->
          <!-- <img
            v-if="game.status === 'post-loading'"
            key="post-loading"
            :src="campaign.image_of_content_after_load"
            alt="image_of_content_after_load"
            class="img-fluid mx-auto"
          /> -->

          <!-- Prize Content -->
          <div v-show="game.status === 'prize'" key="finish">
            <img
              v-show="game.displayWin"
              :src="campaign.image_of_content_win"
              alt="image_of_content_win"
              class="img-fluid mx-auto"
            />
            <img
              v-show="!game.displayWin"
              :src="campaign.image_of_content_lose"
              alt="image_of_content_lose"
              class="img-fluid mx-auto"
            />
          </div>
        </div>

        <div class="card-footer border-0"
          :class="{
            'btn-padding': (game.status === 'start')
          }"
        >
          <div v-if="game.status === 'prize'" class="row mb-4">
            <template v-if="game.displayWin">
              <div class="col-12 mb-3">
                <p
                  class="m-0 text-center font-weight-bold"
                  style="font-size: 2rem !important; color: #ee3618 !important"
                >
                  <span v-if="campaign.num_of_repetition > 1"
                    >{{ game.turn }}回目</span
                  >あたり！！
                </p>
                <!--<p
                  class="m-0 text-center text-danger font-weight-bold"
                  style="color: #ee3618 !important"
                >
                  おめでとうございます！
                </p>-->
              </div>

              <div class="col-12 mt-2">
                <button
                  type="button"
                  @click="handleNextTurn()"
                  class="btn btn-block background-danger border-0 text-white"
                  style="border-radius: 1rem"
                >
                  <p class="m-0 text-bold font-weight-bold">
                    あと{{
                      parseInt(campaign.num_of_repetition) -
                      parseInt(game.turn)
                    }}回で当選
                  </p>
                </button>
              </div>
            </template>

            <template v-else>
              <div class="col-12 mb-3">
                <p
                  class="m-0 text-center font-weight-bold"
                  style="font-size: 2rem !important; color: #a9a9a9 !important"
                >
                  はずれ
                </p>
                <p
                  class="m-0 text-center text-muted font-weight-bold"
                  style="color: #a9a9a9 !important"
                >
                  残念でした。。。
                </p>
              </div>
            </template>
          </div>

          <div v-else-if="(game.status === 'start')" class="text text-center text-muted">
            <button class="btn btn-full btn-danger normal-btn"
              type="button"
              style="border-radius: 0 0 1rem 1rem;"
              @click="runGame()">
              <p class="m-1 font-weight-bold text-bold">{{ campaign.button_text}}</p>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Cautions Label and Cautions Details -->
    <cautions :cautions="cautions"></cautions>
  </div>
</template>

<script>
import {
  getCampaignId,
  getCampaignContents,
  getCampaignImageContents,
  setPrize,
  setState,
  getCampaignCautions,
  setIsShared,
  getPrize,
  removePrize
} from "@/utils/campaign";
import { setErrorMessage } from "@/utils/error";

import { joinCampaign } from "@/api/campaign";

import Cautions from "@/components/Cautions.vue";

export default {
  components: {
    Cautions,
  },
  data() {
    return {
      campaign: {
        name: "",
        description: "",
        button_text: "",
        num_of_repetition: 0,
        image_of_content_top: [],
        image_of_content_before_load: "",
        image_of_content_load: "",
        image_of_content_after_load: "",
        image_of_content_win: "",
        image_of_content_lose: "",
      },
      game: {
        isWin: false,
        displayWin: true,
        status: "start", // start, pre-loading, loading, post-loading, result, finish
        isPlaying: false,
        turn: 0,
        remainedRepetation: 0,
      },
      cautions: "",
      default_data: {
        image_of_content_top: [
          require("@/assets/img/campaign/image_of_content_top.jpg")
        ],
        image_of_content_before_load: require("@/assets/img/campaign/image_of_content_before_load.gif"),
        image_of_content_load: require("@/assets/img/campaign/image_of_content_load.gif"),
        image_of_content_after_load: require("@/assets/img/campaign/image_of_content_after_load.gif"),
        image_of_content_win: require("@/assets/img/campaign/image_of_content_win.jpg"),
        image_of_content_lose: require("@/assets/img/campaign/image_of_content_lose.jpg"),
      },
      turnDisplay: 1,
      activeTopIndex: 0,
      hasTopImage: false
    };
  },
  beforeRouteEnter(to, from, next) {
    // get campaign id from cookies
    const data = {
      campaign_id: getCampaignId(),
    };

    // TODO: uncomment this
    // call joinCampaign from api
    joinCampaign(data)
      .then((response) => {
        // check if campaign has ended
        if (response.status === "campaign_end") {
          return next("/campaign-ended");
        }

        // check if campaign has already retried
        if (response.status === "is_retry") {
          return next("/retried-campaign");
        }

        // TODO: change this
        if (response.status === "success") {
          // if (response) {
          // check if have prize and save to cookies
          if (response.result.prizes) {
            // let prize = {};
            // prize.application_date = response.result.application_date;
            // prize.prizes = response.result.prizes;
            // prize.prizecodes = response.result.prizecodes;
            // prize.campaign_name = response.result.campaign_name;
            let prize2 = {
              'campaign_name': response.result ? response.result.campaign_name : "",
              'name': response.result.prizes ? response.result.prizes.name : "",
              'imageUrl': response.result.prizes.image_of_prize,
              'type': response.result.prizes ? response.result.prizes.type : 0,
              'date': response.result.prizes ? response.result.application_date : "",
              'google_form': response.result.prizes ? response.result.prizes.google_form_url : null,
              'code': response.result.prizecodes ? response.result.prizecodes.code : null,
              'externalUrl': response.result.prizes ? response.result.prizes.external_url : ""
            }
            // set prize to cookies
            if (getPrize()) {
              removePrize();
            }
            setPrize(prize2);

            if (response.result.prizecodes) {
              setState("win-digital");
            } else {
              setState("win-physical");
            }
          } else {
            setState("lose");
          }

          // Check num of repetition to finish game
          const contents = getCampaignContents();
          if (!contents || (contents && contents.num_of_repetition == 0)) {
            if (response.result.result) {
              return next("/game-win");
            } else {
              setIsShared(0)
              return next("/game-lose");
            }
          }

          // add image url list
          const imagesList = [
            require("@/assets/img/campaign/image_of_content_top.jpg"),
            require("@/assets/img/campaign/image_of_content_before_load.gif"),
            require("@/assets/img/campaign/image_of_content_load.gif"),
            require("@/assets/img/campaign/image_of_content_after_load.gif"),
            require("@/assets/img/campaign/image_of_content_win.jpg"),
            require("@/assets/img/campaign/image_of_content_lose.jpg"),
          ];

          // get campaign image url from cookies
          const imageContents = getCampaignImageContents();

          // push campaign image to imagesList array
          if (imageContents) {
            // Handler mutil top image
            const topImages = imageContents.shift();

            // Check required top image
            if (topImages.length == 0) {
              throw 'error'
            }

            topImages.forEach((imageLink) => {
              const imageUrl = imageLink.image_of_content;
              imagesList.push(imageUrl);
            })

            // 演出用のローディング画像を格納してるように見るが、あんま意味なさそう
            imageContents.forEach((image, index) => {
              if (index == 3 || index == 4) {
                const imageUrl = image.image_of_content;
                imagesList.push(imageUrl);
              } else if (image) {
                const imageUrl = image.image_of_content;
                imagesList.push(imageUrl);
              }
            });
          }

          // load every image
          const images = imagesList.map((imageSrc) => {
            return new Promise((resolve, reject) => {
              const img = new Image();
              img.src = imageSrc;
              img.onload = resolve;
              img.onerror = reject;
            });
          });

          Promise.all(images)
            .then(() => {
              console.log("All images loaded!");
            })
            .catch((error) => {
              console.error("Error getting image", error);
            })
            // TODO: solve the problem when one of images not loaded and call next right away before loading all
            .finally(() => {
              return next((vm) => {
                // set win status
                vm.setGameWinStatus(!!response.result.result);

                // set caution data
                vm.setCampaignCautions(response.result.caution);
              });
            });
        } else {
          throw new Error(response);
        }
      })
      .catch((error) => {
        console.error(error.message);
        setErrorMessage(error.statusCode);
        return next("/error");
      });
  },
  created() {
    const contents = getCampaignContents();
    const imageContents = getCampaignImageContents();

    // check campaign content existences from cookies and apply to data
    if (contents) {
      this.campaign.name = contents.name || "";
      this.campaign.description = contents.description || "";
      this.campaign.button_text = contents.button_text || "";
      this.campaign.num_of_repetition = contents.num_of_repetition || 0;
    }

    // check campaign image content existences from cookies and apply to data
    if (imageContents) {
      // Handler mutil top image
      const topImages = imageContents.shift();
      topImages.forEach((imageLink) => {
        let imageUrl = imageLink.image_of_content;

        this.hasTopImage = true
        this.campaign.image_of_content_top.push(imageUrl);
      })

      imageContents.forEach((image) => {
        if (image) {
          let imageUrl = process.env.BASE_API + image.image_of_content;

          switch (image.type) {
            // pre-loading
            case 10:
              this.campaign.image_of_content_before_load = imageUrl;
              break;
            // loading
            case 11:
              this.campaign.image_of_content_load = imageUrl;
              break;
            // post-loading
            case 12:
              this.campaign.image_of_content_after_load = imageUrl;
              break;
            // win
            case 20:
              this.campaign.image_of_content_win = imageUrl;
              break;
            // lose
            case 30:
              this.campaign.image_of_content_lose = imageUrl;
              break;
            default:
              console.error("Invalid or unknown value");
          }
        }
      });
    } else {
      console.error(
        "No image contents found. Changing to default campaign images."
      );

      this.campaign.image_of_content_top =
        this.default_data.image_of_content_top;
      this.campaign.image_of_content_before_load =
        this.default_data.image_of_content_before_load;
      this.campaign.image_of_content_load =
        this.default_data.image_of_content_load;
      this.campaign.image_of_content_after_load =
        this.default_data.image_of_content_after_load;
      this.campaign.image_of_content_win =
        this.default_data.image_of_content_win;
      this.campaign.image_of_content_lose =
        this.default_data.image_of_content_lose;
    }

    // // TODO: delete this set default data later
    // this.game.isWin = Math.random() >= 0.5;
    // this.campaign.num_of_repetition = Math.floor(Math.random() * 5 + 1);
    // this.campaign.name = "Campaign name";
    // this.campaign.description = "Desciption here";

    // // set game remained repetation
    // if (this.game.isWin) {
    //   this.game.remainedRepetation = this.campaign.num_of_repetition;
    // } else {
    //   this.game.remainedRepetation = Math.floor(
    //     Math.random() * this.campaign.num_of_repetition + 1
    //   );
    // }
  },
  methods: {
    setGameWinStatus(status) {
      this.game.isWin = status;

      if (this.game.isWin) {
        this.game.remainedRepetation = this.campaign.num_of_repetition;
      } else {
        this.game.remainedRepetation = 2 + Math.floor(
          Math.random() * (this.campaign.num_of_repetition - 1)
        );
      }
    },
    setCampaignCautions(cautions) {
      this.cautions = cautions;
    },
    async runGame() {
      if (this.game.isPlaying) {
        return;
      }

      this.game.isPlaying = true;

      try {
        this.game.turn++;
        this.game.remainedRepetation--;

        if (this.campaign.image_of_content_before_load) {
          await this.changeStateByTime("pre-loading", 0);
          await this.changeStateByTime("prize", 5000);
        }
        else{
          await this.changeStateByTime("prize", 0);
        }
        
        // if (this.campaign.image_of_content_load) {
        //   await this.changeStateByTime("loading", 5000);
        // }

        // if (this.campaign.image_of_content_after_load) {
        //   await this.changeStateByTime("post-loading", 5000);
        // }

        // display win with last repetation
        if (this.game.remainedRepetation === 0) {
          this.game.displayWin = this.game.isWin;
        }

        if (this.game.remainedRepetation <= 0) {
          this.handleFinish();
        }
      } catch (error) {
        console.error(error);
      }

      this.game.isPlaying = false;
    },
    async handleNextTurn() {
      if (this.game.remainedRepetation > 0) {
        this.turnDisplay++
          if(this.campaign.image_of_content_before_load){
            this.campaign.image_of_content_before_load = this.campaign.image_of_content_before_load+"?"+this.turnDisplay;
          }
        await this.changeStateByTime("start", 0);
      }
    },
    handleFinish() {
      if (this.game.isWin) {
        return this.$router.push("/game-win");
      } else {
        setIsShared(0)
        return this.$router.push("/game-lose");
      }
    },
    changeStateByTime(state, milisecond) {
      return new Promise((resolve, reject) => {
        if (typeof state !== "string" || typeof milisecond !== "number") {
          reject(
            "Invalid value, state is " +
              typeof state +
              ", milisecond is " +
              typeof milisecond
          );
        }

        setTimeout(() => {
          //console.log(state);
          this.game.status = state;
          resolve();
        }, milisecond);
      });
    },
    selectTopImage(index) {
      this.activeTopIndex = index
    }
  },
};
</script>

<style scoped>
.active-image {
  border: red solid 1px;
  border-radius: 10px;
}

.fixed-height-img {
  width: 100%;
  height: auto;
}

.card-flex{
  flex: 0 0 33.333333%;
  max-width: 33.333333%;
}

</style>
